import HeaderState from "@aus/Store/Pages/Header/HeaderState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: HeaderState = {
    isSecondaryHeader: false,
};

const reducer = {
    "Pages/Header/UpdateHeaderState": (draft: Draft<HeaderState>, action: { parameter: HeaderState }) => {
        draft.isSecondaryHeader = action.parameter.isSecondaryHeader;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
